import { c as _c } from "react/compiler-runtime";
import { FormField, FormTextArea, useRequiredValidation } from "./internal/Form";
export function FormTextAreaField(t0) {
  const $ = _c(10);
  const {
    label,
    name,
    gridArea,
    required,
    placeholder
  } = t0;
  useRequiredValidation(name, label, required);
  let t1;
  if ($[0] !== name || $[1] !== placeholder || $[2] !== required) {
    t1 = <FormTextArea name={name} required={required} placeholder={placeholder} />;
    $[0] = name;
    $[1] = placeholder;
    $[2] = required;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== gridArea || $[5] !== label || $[6] !== name || $[7] !== required || $[8] !== t1) {
    t2 = <FormField label={label} name={name} required={required} gridArea={gridArea}>{t1}</FormField>;
    $[4] = gridArea;
    $[5] = label;
    $[6] = name;
    $[7] = required;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}